export default {
  LIST_FETCHED: 'CATEGORIES_FETCHED',
  LIST_LOAD: 'CATEGORIES_LOAD',
  ITEM_DETAIL: 'CATEGORIES_DETAIL',
  BUTTON_LOAD: 'CATEGORIES_BUTTON_LOAD',
  USAGE_LOAD: 'CATEGORIES_USAGE_LOAD',
  USAGE_FETCHED: 'CATEGORIES_USAGE_FETCHED',
  USAGE_RESET: 'CATEGORIES_USAGE_RESET',
  DELETE_LOAD: 'CATEGORIES_DELETE_LOAD',
};
